import {
  MarketingSection,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";
import { cn } from "@/lib/utils";

const TIPS = [
  {
    title: "Get the balance right",
    body: "Make sure your vocals, instruments, and effects sound the way you want them. Lutely's mastering puts the finishing touches on your mix.",
    className: "border-blue-600 bg-[linear-gradient(145deg,#fff,#eef1ff)]",
  },
  {
    title: "Leave room for mastering",
    body: "Avoid clipping or heavy limiting just to make your mix louder. Leave headroom for mastering to shape the sound and bring it to its finished level.",
    className: "border-[#FF4F9A] bg-[linear-gradient(145deg,#fff,#fff0f7)]",
  },
  {
    title: "Upload your best file",
    body: "Start with your highest-quality final mix, preferably WAV or AIFF.",
    className: "border-teal-500 bg-[linear-gradient(145deg,#fff,#effff8)]",
  },
];

export default function MasteringPrep() {
  return (
    <MarketingSection className="bg-white">
      <SectionKicker>Preparing your mix</SectionKicker>
      <SectionTitle>A great master starts with a good mix.</SectionTitle>
      <div className="mt-12 grid grid-cols-[repeat(3,1fr)] gap-[22px] max-[680px]:grid-cols-1">
        {TIPS.map((tip, i) => (
          <article
            key={tip.title}
            className={cn(
              "rounded-[22px] border-t-[3px] p-[30px] font-open-sans text-[16px] leading-[1.55] shadow-[0_12px_38px_rgba(15,26,75,0.07)]",
              tip.className,
            )}
          >
            <span className="font-figtree text-[15px] font-black leading-none text-blue-600">
              0{i + 1}
            </span>
            <h3 className="mb-[10px] mt-[34px] font-figtree text-[23px] font-[850] leading-[1.15]">
              {tip.title}
            </h3>
            <p className="m-0 text-marketing-muted">{tip.body}</p>
          </article>
        ))}
      </div>
    </MarketingSection>
  );
}
